export const isNewStore = (createdAt: string | undefined): boolean => {
  if (!createdAt) return false;
  const sixMonthsAgo = new Date();
  sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
  return new Date(createdAt) >= sixMonthsAgo;
};
